import React from "react";
import Sidebar from "../components/layout/SideBarComponent";
import AppHeader from "../components/layout/AppHeaderComponent";

import { Layout } from "antd";
import DocumentSingleComponent from "../components/document/DocumentSingleComponent";
const { Content } = Layout;

export default function DocumentSingle() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader />
      <Sidebar />

      <Content
        style={{
          marginTop: 64,
          marginLeft: 200,
          padding: 24,
          background: "#f0f2f5",
        }}
      >
        <DocumentSingleComponent />
      </Content>
    </Layout>
  );
}
